import { useQuery } from "@tanstack/react-query";
import { getAllAssign, getAllQuiz } from "../api/assignAndQuizApi";

export const useHandleAssignAndQuiz = () => {
  const {
    data: rawQuizzes,
    isLoading: isQuizzesLoading,
    isError: isQuizzesError,
  } = useQuery({
    queryKey: ["quizzes"],
    queryFn: () => getAllQuiz(),
    refetchOnWindowFocus: false,
    refetchOnMount: false, // Không gọi lại khi component được mount
    staleTime: 60000,
  });

  const quizzes = rawQuizzes?.quizzes || []; // Extract the actual quizzes array

  const {
    data: rawAssigns,
    isLoading: isAssignsLoading,
    isError: isAssignsError,
  } = useQuery({
    queryKey: ["assigns"],
    queryFn: () => getAllAssign(),
    refetchOnWindowFocus: false,
    refetchOnMount: false, // Không gọi lại khi component được mount
    staleTime: 60000,
  });
  
  const assigns = rawAssigns?.assignments || []; // Extract the actual assignments array

  return {
    quizzes,
    isQuizzesLoading,
    isQuizzesError,
    assigns,
    isAssignsLoading,
    isAssignsError,
  };
};
